import { SVGAttributes } from 'react';

export const PureBlueTriangles = ({ className }: SVGAttributes<SVGSVGElement>) => (
  <svg
    className={className}
    width="84"
    height="36"
    viewBox="0 0 84 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.224609 35.2723V0.296875L21.0433 17.3682L0.224609 35.2723Z" fill="#D4EFF4" />
    <path d="M41.8613 35.2723V0.296875L62.6801 17.3682L41.8613 35.2723Z" fill="#D4EFF4" />
    <path d="M21.043 35.2723V0.296875L41.8617 17.3682L21.043 35.2723Z" fill="#D4EFF4" />
    <path d="M62.6816 35.2723V0.296875L83.5004 17.3682L62.6816 35.2723Z" fill="#D4EFF4" />
  </svg>
);

PureBlueTriangles.displayName = 'HiringHero_PureBlueTriangles';
